import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FF383B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.702 17C19.524 17 21 15.543 21 13.743v-2.592A2.16 2.16 0 0 1 18.823 9c0-1.19.971-2.15 2.177-2.15l-.001-2.594c0-1.8-1.477-3.257-3.298-3.257H4.3C2.478 1 1 2.457 1 4.257L1 6.935c1.206 0 2.177.875 2.177 2.066s-.971 2.15-2.177 2.15v2.592C1 15.543 2.476 17 4.298 17z",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FF383B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15 1.25v2.42M15 14.76v2.024M15 11.325V6.504",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FF383B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 8.995c0-.811-4.157-3.406-4.63-2.94-.47.467-.516 5.369 0 5.88.518.512 4.63-2.129 4.63-2.94",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }